import AccordionCollapse from 'react-bootstrap/AccordionCollapse'
import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'

export const ExpandableGridContainer = styled.div.attrs({
  className: 'expandable-grid-container',
})`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 0 0 24px;
`

export const ExpandableGridAccordionCollapse = styled(AccordionCollapse)<{
  $gridRow?: number
  $noMaxHeight?: boolean
}>`
  grid-column: 1 / -1;
  grid-row: ${({ $gridRow }) => ($gridRow ? $gridRow + 1 : undefined)};
  max-height: ${({ $noMaxHeight }) => ($noMaxHeight ? 'none' : '300px')};
  overflow-y: ${({ $noMaxHeight }) => ($noMaxHeight ? 'visible' : 'auto')};
  margin-bottom: 10px;
  margin-top: 5px;
  padding-right: 8px;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 4px;
    margin: 16px 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${palette.neutral[300]};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${palette.neutral[400]};
  }

  /* Firefox scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: ${palette.neutral[300]} transparent;
`
